// extracted by mini-css-extract-plugin
export default {"downArrow":"styles_downArrow__J4O8Y","dark":"styles_dark__x67dq"};